import Colors from '../../../../shared/assets/style/default/color';
import Fonts from '../../../../shared/assets/style/default/fonts';
import Screen from '../../../../shared/utils/screen';
import styled from 'styled-components';

const UpgradePlanModalTitle = styled.div<React.CSSProperties>`
  color: ${Colors['light']};
  font-family: ${Fonts['regular']};
  font-size: ${40 * Screen.widthRatio}px;
  margin-left: ${520 * Screen.widthRatio}px;
  margin-top: ${40 * Screen.widthRatio}px;
  width: ${880 * Screen.widthRatio}px;
  margin-bottom: ${60 * Screen.widthRatio}px;
`;

export default UpgradePlanModalTitle;
